import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 40px 0;
  max-width: 700px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  text-align: center;
  margin-bottom: 32px;
`;

export const TypeSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
`;

export const StepsWrapper = styled.div`
  margin-bottom: 40px;
`;

export const FormSection = styled.div`
  background: ${({ theme }) => theme.colors.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  padding: 32px;
  margin-bottom: 24px;
`;

export const StepTitle = styled.h3`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin-bottom: 24px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
`;
